import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

const flightItemSchema = z.object({
  createdBy: z.number(),
  updatedBy: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  id: z.string(),
  name: z.string(),
  activityId: z.string(),
  budget: z.string(),
  dateFrom: z.string(),
  dateTo: z.string(),
  minDate: z.string(),
  maxDate: z.string(),
});

const additionalSchema = z.object({
  isLastFlightDeletable: z.boolean(),
  customFlightCanBeCreated: z.boolean(),
  totals: z.object({
    budget: z.string(),
    dateFrom: z.string().nullable(),
    dateTo: z.string().nullable(),
  }),
});

export const updateFlightRequestSchema = z.object({
  name: z.string().optional(),
  budget: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});

export const updatedFlightResponseSchema = createResponseSchema(
  updateFlightRequestSchema,
);

export const flightsListSchema = createResponseSchema(
  flightItemSchema,
  additionalSchema,
);

export const flightVersionSchema = z.object({
  id: z.union([z.string(), z.null()]),
  name: z.string(),
  createdAt: z.string(),
  index: z.number(),
  isCurrent: z.boolean(),
});

export const flightsListItemSchema = createResponseSchema(flightItemSchema);
export const flightVersionResponseSchema =
  createResponseSchema(flightVersionSchema);
export const createdFlightVersionResponseSchema = createResponseSchema(
  flightVersionSchema.omit({ isCurrent: true }),
);
